import { lazy } from "react";
// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const GoalsViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-goalsview" */ "./PlanGoalsView")).then((page)=>{
        return {
            default: page.PlanGoalsView
        };
    });
export const LazyPlanGoalsView = /*#__PURE__*/ lazy(GoalsViewLazyLoader);
